import styled, { css } from 'styled-components';

export const minContainerWidth = 232;
export const initialContainerWidth = 264;
export const maxContainerWidth = 464;

export const ResizeHandle = styled.span<{
  $isResizing: boolean;
  $position: 'e' | 'w';
}>`
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  cursor: col-resize;
  background: transparent;

  transition: background 200ms;

  &:hover {
    background: ${({ theme }) => theme.palette.divider};
  }

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: block;
  }

  ${({ $position }) =>
    $position === 'e'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `};

  ${({ theme, $isResizing }) =>
    $isResizing &&
    css`
      background: ${theme.palette.divider};
    `};
`;

export const Content = styled.div<{
  $smoothTransition?: boolean;
  $isResizing?: boolean;
}>`
  position: relative;
  height: 100%;

  ${({ $smoothTransition, $isResizing }) =>
    $smoothTransition && !$isResizing
      ? css`
          transition: width 0.3s ease;
        `
      : ''};
`;
